import { isNil, uniqBy } from 'lodash';
import {
  useLocation,
  matchRoutes as reactRouterMatchRoutes,
} from 'react-router-dom';

const useMatchRoutes = () => {
  const { pathname } = useLocation();
  const matchRoutes = (routes = { props: { children: [] } }) => {
    const mappedRoutes = routes.props.children.map(({ props }) => ({
      path: props?.path,
    }));

    return !isNil(
      reactRouterMatchRoutes(uniqBy(mappedRoutes, 'path'), pathname),
    );
  };

  return { matchRoutes };
};

export default useMatchRoutes;
